<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :error="error"
        class="card-invoice_staff"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
    >
        <template #title>
            {{ name }}
        </template>
        <template #actions>
            <CompassIconButton v-if="settings.canCreate" icon="plus" @click="addAction" />
        </template>
        <template #content>
            <template-kpi-card :data="{ stats: cardData, labels: labels }" />
            <Teleport to="#dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </Teleport>
        </template>

        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import TemplateKpiCard from './TemplateKpiCard.vue';
import CardMixin from './CardMixin.js';
import InvoiceMixin from './InvoiceMixin.js';
import FiscalYearFooter from './FiscalYearFooter.vue';

export default {
    components: {
        LayoutCard,
        TemplateKpiCard,
        FiscalYearFooter,
    },
    mixins: [CardMixin, InvoiceMixin],
    methods: {
        addAction() {
            var title = this.$l10n.__('Créer une facture');
            DocTools.createForThird('invoice', title);
        },
    },
};
</script>
